import { apiClient } from '@/shared/api/client'

export const getConversation = async (partnerId) => {
  const response = await apiClient.get(`/messages/conversation/${partnerId}`)
  return response.data.data
}

export const sendMessage = async (payload) => {
  const response = await apiClient.post('/messages', payload)
  return response.data.data
}

export const markMessagesAsRead = async (partnerId) => {
  const response = await apiClient.patch(`/messages/read/${partnerId}`)
  return response.data.data
}

export const getUnreadCounts = async () => {
  const response = await apiClient.get('/messages/unread-count')
  return response.data.data
}

export const getAdminContact = async () => {
  const response = await apiClient.get('/messages/admin-contact')
  return response.data.data
}
